import { render } from "./portfolioAnalysis.vue?vue&type=template&id=1d70d252"
import script from "./portfolioAnalysis.vue?vue&type=script&lang=js"
export * from "./portfolioAnalysis.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__